import { APP_OPTIONS, type AppOptions } from '@user-management/permission-list';
import { Navigate, useParams } from '@user-management/router';
import { Outlet } from 'react-router-dom';

export default function PermissionDetailsByAppLayout() {
  const { appRoleId, app } = useParams('/roles-and-permissions/:appRoleId/permissions/:app');

  if (!APP_OPTIONS.includes(app as AppOptions)) {
    return (
      <Navigate
        to='/roles-and-permissions/:appRoleId/permissions/:app'
        params={{ appRoleId, app: 'exam-management' }}
        replace
      />
    );
  }

  return <Outlet />;
}
